import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { NgMapsCoreModule } from '@ng-maps/core';
import { NgMapsGoogleModule } from '@ng-maps/google';
import { FileUploadModule } from 'ng2-file-upload';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { DivergentPriceCollapseComponent } from 'src/app/components/adjustments/divergent-price-collapse/divergent-price-collapse.component';
import { InternalInfoComponent } from 'src/app/components/adjustments/internal-info/internal-info.component';
import { AdjustmentIPBoardAppointmentComponent } from 'src/app/components/project-placement-picker/ip-board-appointment/adjustment-ip-board-appointment/adjustment-ip-board-appointment.component';
import { ClientAdjustmentDesignCollapseComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-design/client-adjustment-design-collapse/client-adjustment-design-collapse.component';
import { ClientAdjustmentDesignContentComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-design/client-adjustment-design-content/client-adjustment-design-content.component';
import { ClientAdjustmentDesignDialogComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-design/client-adjustment-design-dialog/client-adjustment-design-dialog.component';
import { ClientAdjustmentActionsComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-detail/client-adjustment-actions/client-adjustment-actions.component';
import { ClientAdjustmentExecutionInfoComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-detail/client-adjustment-execution-info/client-adjustment-execution-info.component';
import { ClientAdjustmentFormSharedComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-detail/client-adjustment-form/client-adjustment-form-shared/client-adjustment-form-shared.component';
import { ClientAdjustmentFormComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-detail/client-adjustment-form/client-adjustment-form.component';
import { StickerSelectComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-detail/client-adjustment-form/sold-rented-sticker-select/sold-rented-sticker-select.component';
import { ClientAdjustmentHeaderComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-detail/client-adjustment-header/client-adjustment-header.component';
import { ClientAdjustmentCompanyInvoiceInfoComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-detail/client-adjustment-invoice-info/client-adjustment-company-invoice-info/client-adjustment-company-invoice-info.component';
import { ClientAdjustmentInvoiceInfoComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-detail/client-adjustment-invoice-info/client-adjustment-invoice-info.component';
import { ClientAdjustmentPendingExecutedComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-detail/client-adjustment-pending-executed/client-adjustment-pending-executed.component';
import { ClientAdjustmentSummaryComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-detail/client-adjustment-summary/client-adjustment-summary.component';
import { ClientAdjustmentPrintworkDialogComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-printwork/client-adjustment-printwork-dialog/client-adjustment-printwork-dialog.component';
import { ClientDetailActionsComponent } from 'src/app/pages/client-corner/client-project-detail/client-pending-detail/client-detail-actions/client-detail-actions.component';
import { ConfigurationCardComponent } from 'src/app/pages/client-corner/client-project-detail/client-pending-detail/detail-card/configuration-card/configuration-card.component';
import { DesignCardComponent } from 'src/app/pages/client-corner/client-project-detail/client-pending-detail/detail-card/design-card/design-card.component';
import { DetailCardComponent } from 'src/app/pages/client-corner/client-project-detail/client-pending-detail/detail-card/detail-card.component';
import { ExecutionCardComponent } from 'src/app/pages/client-corner/client-project-detail/client-pending-detail/detail-card/execution-card/execution-card.component';
import { FacturationCardComponent } from 'src/app/pages/client-corner/client-project-detail/client-pending-detail/detail-card/facturation-card/facturation-card.component';
import { PlacementCardAppointmentInfoComponent } from 'src/app/pages/client-corner/client-project-detail/client-pending-detail/detail-card/placement-card/placement-card-appointment-info/placement-card-appointment-info.component';
import { PlacementCardIPBoardExtrasInfoComponent } from 'src/app/pages/client-corner/client-project-detail/client-pending-detail/detail-card/placement-card/placement-card-ip-board-extras-info/placement-card-ip-board-extras-info.component';
import { PlacementCardComponent } from 'src/app/pages/client-corner/client-project-detail/client-pending-detail/detail-card/placement-card/placement-card.component';
import { ClientSubProjectOnHoldCollapseComponent } from 'src/app/pages/client-corner/client-project-detail/client-sub-project-on-hold/client-sub-project-on-hold-collapse/client-sub-project-on-hold-collapse.component';
import { ClientSubProjectOnHoldContentComponent } from 'src/app/pages/client-corner/client-project-detail/client-sub-project-on-hold/client-sub-project-on-hold-content/client-sub-project-on-hold-content.component';
import { TestUnassignedExpiredSubProjectsModalComponent } from 'src/app/pages/immo-ip/test-unassign-expired-subprojects/test-unassign-expired-subprojects-modal.component';
import { IPBoardDelayComponent } from 'src/app/pages/projects/helpers/ip-board-delay/ip-board-delay.component';
import { IPBoardExecutedComponent } from 'src/app/pages/projects/helpers/ip-board-executed/ip-board-executed.component';
import { IPBoardAdjustmentCompanyInvoiceComponent } from 'src/app/pages/projects/helpers/ip-board-invoicing/adjustment/ip-board-adjustment-company-invoice/ip-board-adjustment-company-invoice.component';
import { IPBoardAdjustmentInvoicingComponent } from 'src/app/pages/projects/helpers/ip-board-invoicing/adjustment/ip-board-adjustment-invoicing.component';
import { IPBoardCompanyInvoiceComponent } from 'src/app/pages/projects/helpers/ip-board-invoicing/ip-board-company-invoice/ip-board-company-invoice.component';
import { IPBoardInvoicingComponent } from 'src/app/pages/projects/helpers/ip-board-invoicing/ip-board-invoicing.component';
import { IPBoardTourSelectorComponent } from 'src/app/pages/projects/helpers/ip-board-sub-project-tour-selector/ip-board-tour-selector.component';
import { AppRoutingModule } from '../app-routing.module';
import { AppointmentCollapseComponent } from '../components/adjustments/appointment-collapse/appointment-collapse.component';
import { StickerFacturationComponent } from '../components/adjustments/edit-ip-adjustment/sticker-facturation/sticker-facturation.component';
import { DisplayNotExecutedHistoryItemComponent } from '../components/adjustments/execution-collapse/display-not-executed-history-item/display-not-executed-history-item.component';
import { ExecutionCollapseComponent } from '../components/adjustments/execution-collapse/execution-collapse.component';
import { EmployeeCircleDisplayComponent } from '../components/employee-circle-display/employee-circle-display.component';
import { SignInfoComponent } from '../components/sign-information/sign-info/sign-info.component';
import { ImmoStudioAssignModalComponent } from '../components/immo-studio-assign-modal/immo-studio-assign-modal.component';
import { ImpersonateIconComponent } from '../components/impersonate-icon/impersonate-icon.component';
import { NotificationModalComponent } from '../components/notification-modal/notification-modal.component';
import { IPBoardAppointmentComponent } from '../components/project-placement-picker/ip-board-appointment/ip-board-appointment.component';
import { IPBoardArrowsComponent } from '../components/project-placement-picker/ip-board-extras/ip-board-arrows/ip-board-arrows.component';
import { IPBoardExtrasComponent } from '../components/project-placement-picker/ip-board-extras/ip-board-extras.component';
import { IpBoardHeightComponent } from '../components/project-placement-picker/ip-board-extras/ip-board-height/ip-board-height.component';
import { IPBoardSecondBoardComponent } from '../components/project-placement-picker/ip-board-extras/ip-board-second-board/ip-board-second-board.component';
import { ProjectPlacementPickerComponent } from '../components/project-placement-picker/project-placement-picker.component';
import { TourItemRegisteredComponent } from '../components/tour-item-registered/tour-item-registered.component';
import { FilterInputComponent } from '../helpers/filter-input/filter-input.component';
import { FilterNotTrueBooleanComponent } from '../helpers/filter-not-true-boolean/filter-not-true-boolean.component';
import { FilterCheckboxComponent } from '../helpers/filter-checkbox/filter-checkbox.component';
import { MapComponent } from '../helpers/googlemaps/map/map.component';
import { PriceLineInputComponent } from '../helpers/price-line/price-line-input/price-line-input.component';
import { PriceLinePickerComponent } from '../helpers/price-line/price-line-picker/price-line-picker.component';
import { TextFieldFilterComponent } from '../helpers/text-field-filter/text-field-filter.component';
import { AppPipesModule } from '../modules/app-pipes/app-pipes.module';
import { FacturationRowComponent } from '../pages/client-corner/client-project-detail/client-pending-detail/detail-card/facturation-card/ip-board-facturation-row/facturation-row.component';
import { NoAccessComponent } from '../pages/no-access/no-access.component';
import { ClientBaseProjectPriceSummaryComponent } from '../pages/projects/client-corner/create-view-base-project/client-base-project-summary/client-base-project-price-summary/client-base-project-price-summary.component';
import { ClientIPBoardArrowsSummaryComponent } from '../pages/projects/client-corner/create-view-base-project/client-base-project-summary/client-product-summary/client-ip-board-arrows-summary/client-ip-board-arrows-summary.component';
import { DesignStepComponent } from '../pages/projects/client-corner/create-view-base-project/design-step/design-step.component';
import { PlacementStepComponent } from '../pages/projects/client-corner/create-view-base-project/placement-step/placement-step.component';
import { DisplayDateTimePipe } from '../pipes/display-date-time.pipe';
import { StreetViewComponent } from './app-street-view/app-street-view.component';
import { AsyncEmployeeWithBadge } from './async-employee-with-badge/async-employee-with-badge.component';
import { EmployeeWithBadgeComponent } from './async-employee-with-badge/employee-with-badge/employee-with-badge.component';
import { ClientCompanyPickerComponent } from './client-company-picker/client-company-picker.component';
import { CompanyPickerComponent } from './company-picker/company-picker.component';
import { AsyncInsertionPointDirective } from './directives/async-insertion-point.directive';
import { FocusAndSelectDirective } from './directives/focusAndSelect';
import { HrefExternalUrlDirective } from './directives/href-external-url.directive';
import { NoScrollInputDirective } from './directives/noScrollInput';
import { OnlyNumbersDirective } from './directives/only-numbers';
import { FloorPickerComponent } from './floor-picker/floor-picker.component';
import { LoggedActionDisplayComponent } from './logged-action-display/logged-action-display.component';
import { AtelierNameDatePipe } from './pipes/atelier-name-date.pipe';
import { InitialsPipe } from './pipes/initials.pipe';
import { PendingStatusTooltipPipe } from './pipes/pending-status-tooltip.pipe';
import { PersonNamePipe } from './pipes/person-name.pipe';
import { PlacementPickerComponent } from './placement-picker/placement-picker.component';
import { ProductPlacementPickerComponent } from './product-placement-picker/product-placement-picker.component';
import { BoardFormComponent } from './project-components/board-form/board-form.component';
import { BoardPartFormComponent } from './project-components/board-form/board-part-form/board-part-form.component';
import { BoardPlacementFormComponent } from './project-components/board-form/board-placement-form/board-placement-form.component';
import { ClientIPBoardFormComponent } from './project-components/client-project-form/base-project/client-ip-board-form/client-ip-board-form.component';
import { ClientIPBoardPartFormComponent } from './project-components/client-project-form/base-project/client-ip-board-form/client-ip-board-part-form/client-ip-board-part-form.component';
import { ClientIpCustomBoardFormComponent } from './project-components/client-project-form/base-project/client-ip-board-form/client-ip-custom-board-form/client-ip-custom-board-form.component';
import { ClientSignSelectorComponent } from './project-components/client-project-form/base-project/client-ip-board-form/client-sign-selector/client-sign-selector.component';
import { ClientProductCreatorComponent } from './project-components/client-project-form/base-project/client-product-wrapper/client-product-creator/client-product-creator.component';
import { ClientProductWrapperComponent } from './project-components/client-project-form/base-project/client-product-wrapper/client-product-wrapper.component';
import { CustomerProjectInfoAllComponent } from './project-components/customer-project-info/customer-project-info-all/customer-project-info-all.component';
import { CustomerProjectInfoOneComponent } from './project-components/customer-project-info/customer-project-info-one/customer-project-info-one.component';
import { CheckboxComponent } from './project-components/helpers/checkbox/checkbox.component';
import { ClientProductPhoneNumberSelectorComponent } from './project-components/helpers/client-product-phone-number-selector/client-product-phone-number-selector.component';
import { CollectKeyFromSelectorComponent } from './project-components/helpers/collect-key-from-selector/collect-key-from-selector.component';
import { DesignPickerComponent } from './project-components/helpers/design-picker/design-picker.component';
import { DualCheckboxComponent } from './project-components/helpers/dual-checkbox/dual-checkbox.component';
import { FilePickerComponent } from './project-components/helpers/file-picker/file-picker.component';
import { HeightAndWidthSelectorComponent } from './project-components/helpers/height-and-width-selector/height-and-width-selector.component';
import { IPBoardPhoneNumberPickerComponent } from './project-components/helpers/ip-board-design-picker/ip-board-association-picker/ip-board-phone-number-picker/ip-board-phone-number-picker.component';
import { IPBoardStickerPickerComponent } from './project-components/helpers/ip-board-design-picker/ip-board-association-picker/ip-board-sticker-picker/ip-board-sticker-picker.component';
import { IPBoardTitlePickerComponent } from './project-components/helpers/ip-board-design-picker/ip-board-association-picker/ip-board-title-picker/ip-board-title-picker.component';
import { IPBoardCollaborativeStickerInputComponent } from './project-components/helpers/ip-board-design-picker/ip-board-collaborative-sticker-input/ip-board-collaborative-sticker-input.component';
import { IPBoardCollaborativeTitlePickerComponent } from './project-components/helpers/ip-board-design-picker/ip-board-collaborative-title-picker/ip-board-collaborative-title-picker.component';
import { IPBoardCustomBoardPhoneNumberPickerComponent } from './project-components/helpers/ip-board-design-picker/ip-board-custom-board-phone-number-picker/ip-board-custom-board-phone-number-picker.component';
import { IPBoardDesignPickerComponent } from './project-components/helpers/ip-board-design-picker/ip-board-design-picker.component';
import { IPBoardDesignPreviewComponent } from './project-components/helpers/ip-board-design-picker/ip-board-design-preview/ip-board-design-preview.component';
import { IPBoardExtraBoardInputComponent } from './project-components/helpers/ip-board-design-picker/ip-board-extra-board-input/ip-board-extra-board-input.component';
import { IPBoardPartPhoneNumberPickerComponent } from './project-components/helpers/ip-board-design-picker/ip-board-part-phone-number-picker/ip-board-part-phone-number-picker.component';
import { IPBoardTextInputComponent } from './project-components/helpers/ip-board-design-picker/ip-board-text-input/ip-board-text-input.component';
import { BoardLoadListComponent } from './project-components/helpers/load-list/board-load-list/board-load-list.component';
import { LoadListComponent } from './project-components/helpers/load-list/load-list.component';
import { NumberInputComponent } from './project-components/helpers/number-input/number-input.component';
import { ProductDescriptionComponent } from './project-components/helpers/product-description/product-description.component';
import { ProductPhoneNumberSelectorComponent } from './project-components/helpers/product-phone-number-selector/product-phone-number-selector.component';
import { ProductTypeCriteriumSelectorComponent } from './project-components/helpers/product-type-criterium-selector/product-type-criterium-selector.component';
import { SelectAutocompleteComponent } from './project-components/helpers/select-autocomplete/select-autocomplete.component';
import { SelectorComponent } from './project-components/helpers/selector/selector.component';
import { TextareaInputComponent } from './project-components/helpers/textarea-input/textarea-input.component';
import { TilingComponent } from './project-components/helpers/tiling/tiling.component';
import { YesNoUnknownComponent } from './project-components/helpers/yes-no-unknown/yes-no-unknown.component';
import { YesNoComponent } from './project-components/helpers/yes-no/yes-no.component';
import { InternalProjectFormComponent } from './project-components/internal-project-form/internal-project-form.component';
import { OtherProductFormComponent } from './project-components/other-product-form/other-product-form.component';
import { OtherProductPlacementFormComponent } from './project-components/other-product-form/other-product-placement-form/other-product-placement-form.component';
import { ProjectTabContentComponent } from './project-components/project-tab-content/project-tab-content.component';
import { ClientWindowStickerFormComponent } from './project-components/windowsticker/client-window-sticker-form/client-window-sticker-form.component';
import { ClientWindowStickerCustomPartFormComponent } from './project-components/windowsticker/client-window-sticker-form/client-window-sticker-part-form/client-window-sticker-custom-part-form/client-window-sticker-custom-part-form.component';
import { ClientWindowStickerPartFormComponent } from './project-components/windowsticker/client-window-sticker-form/client-window-sticker-part-form/client-window-sticker-part-form.component';
import { ClientWindowStickerStandardPartFormComponent } from './project-components/windowsticker/client-window-sticker-form/client-window-sticker-part-form/client-window-sticker-standard-part-form/client-window-sticker-standard-part-form.component';
import { WindowstickerPlacementFormComponent } from './project-components/windowsticker/windowsticker-placement-form/windowsticker-placement-form.component';
import { ProjectTabsComponent } from './projects-tabs/project-tabs.component';
import { RegisteredActionDisplayComponent } from './registered-action-display/registered-action-display.component';
import { TabContentComponent } from './tab-content/tab-content.component';
import { TabsComponent } from './tabs/tabs.component';
import { LabelWithTextAreaComponent } from './textarea-with-label/textarea-with-label.component';
import { TimeBudgetPickerComponent } from './time-budget-picker/time-budget-picker.component';
import { EmployeeRecoveryStatsComponent } from '../components/employee-recovery-stats/employee-recovery-stats.component';
import { SignInfoWrapperComponent } from '../components/sign-information/sign-info-wrapper/sign-info-wrapper.component';
import { FilterDropdownComponent } from '../helpers/filter-dropdown/filter-dropdown.component';

@NgModule({
  imports: [
    CommonModule,
    AppRoutingModule,
    MatCheckboxModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    MatIconModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatRadioModule,
    MatCardModule,
    MatStepperModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    NgxMatTimepickerModule,
    MatMenuModule,
    MatDialogModule,
    MatMomentDateModule,
    MatTableModule,
    MatSelectModule,
    MatSortModule,
    DragDropModule,
    AppPipesModule,
    FileUploadModule,
    A11yModule,
    CollapseModule.forRoot(),
    NgMapsGoogleModule,
    NgMapsCoreModule,
  ],
  exports: [
    AppRoutingModule,
    MatCheckboxModule,
    MatInputModule,
    MatSelectModule,
    MatSnackBarModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatRadioModule,
    MatCardModule,
    MatStepperModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    NgxMatTimepickerModule,
    FileUploadModule,
    TabsComponent,
    TabContentComponent,
    TextareaInputComponent,
    ProjectTabsComponent,
    ProjectTabContentComponent,
    AsyncInsertionPointDirective,
    EmployeeWithBadgeComponent,
    AsyncEmployeeWithBadge,
    PersonNamePipe,
    AtelierNameDatePipe,
    InitialsPipe,
    PendingStatusTooltipPipe,
    MatDialogModule,
    MatTableModule,
    MatSortModule,
    DragDropModule,
    InternalProjectFormComponent,
    CustomerProjectInfoAllComponent,
    CustomerProjectInfoOneComponent,
    TilingComponent,
    StreetViewComponent,
    NoAccessComponent,
    AppPipesModule,
    CheckboxComponent,
    DualCheckboxComponent,
    SelectorComponent,
    YesNoComponent,
    YesNoUnknownComponent,
    SelectAutocompleteComponent,
    LabelWithTextAreaComponent,
    TimeBudgetPickerComponent,
    ProductTypeCriteriumSelectorComponent,
    FilePickerComponent,
    HeightAndWidthSelectorComponent,
    NumberInputComponent,
    TextFieldFilterComponent,
    ProductTypeCriteriumSelectorComponent,
    FilePickerComponent,
    CompanyPickerComponent,
    ClientCompanyPickerComponent,
    LoggedActionDisplayComponent,
    FilterInputComponent,
    FilterDropdownComponent,
    FilterCheckboxComponent,
    FilterNotTrueBooleanComponent,
    NotificationModalComponent,
    ImmoStudioAssignModalComponent,
    PriceLinePickerComponent,
    PriceLineInputComponent,
    FloorPickerComponent,
    RegisteredActionDisplayComponent,
    ExecutionCollapseComponent,
    AppointmentCollapseComponent,
    DisplayNotExecutedHistoryItemComponent,
    DetailCardComponent,
    ConfigurationCardComponent,
    DesignCardComponent,
    PlacementCardComponent,
    PlacementCardAppointmentInfoComponent,
    PlacementCardIPBoardExtrasInfoComponent,
    ExecutionCardComponent,
    FacturationCardComponent,
    ClientDetailActionsComponent,
    ClientAdjustmentHeaderComponent,
    InternalInfoComponent,
    DivergentPriceCollapseComponent,
    IPBoardInvoicingComponent,
    IPBoardDelayComponent,
    IPBoardAppointmentComponent,
    IPBoardTourSelectorComponent,
    IPBoardCompanyInvoiceComponent,
    CollapseModule,
    ClientBaseProjectPriceSummaryComponent,
    ClientIPBoardArrowsSummaryComponent,
    EmployeeCircleDisplayComponent,
    EmployeeRecoveryStatsComponent,
    DisplayDateTimePipe,
    IPBoardAdjustmentInvoicingComponent,
    IPBoardAdjustmentCompanyInvoiceComponent,
    ClientSubProjectOnHoldCollapseComponent,
    ClientSubProjectOnHoldContentComponent,
    ClientAdjustmentDesignCollapseComponent,
    ClientAdjustmentDesignContentComponent,
    ClientAdjustmentDesignDialogComponent,
    ClientAdjustmentPrintworkDialogComponent,
    OnlyNumbersDirective,
    FocusAndSelectDirective,
    NoScrollInputDirective,
    ClientAdjustmentSummaryComponent,
    ClientAdjustmentFormComponent,
    ClientAdjustmentFormSharedComponent,
    ClientAdjustmentActionsComponent,
    ClientAdjustmentPendingExecutedComponent,
    ClientAdjustmentExecutionInfoComponent,
    ClientAdjustmentInvoiceInfoComponent,
    ClientAdjustmentCompanyInvoiceInfoComponent,
    StickerSelectComponent,
    AdjustmentIPBoardAppointmentComponent,
    HrefExternalUrlDirective,
    IPBoardExecutedComponent,
    TestUnassignedExpiredSubProjectsModalComponent,
    MapComponent,
    CollectKeyFromSelectorComponent,
    PlacementStepComponent,
    DesignStepComponent,
    DesignPickerComponent,
    ProductDescriptionComponent,
    ProductPhoneNumberSelectorComponent,
    ClientProductPhoneNumberSelectorComponent,
    IPBoardPartPhoneNumberPickerComponent,
    IPBoardDesignPickerComponent,
    IPBoardDesignPreviewComponent,
    IPBoardExtraBoardInputComponent,
    IPBoardTitlePickerComponent,
    IPBoardPhoneNumberPickerComponent,
    IPBoardTextInputComponent,
    IPBoardStickerPickerComponent,
    IPBoardCustomBoardPhoneNumberPickerComponent,
    IPBoardCollaborativeTitlePickerComponent,
    IPBoardCollaborativeStickerInputComponent,
    PlacementPickerComponent,
    ProjectPlacementPickerComponent,
    ProductPlacementPickerComponent,
    WindowstickerPlacementFormComponent,
    BoardPlacementFormComponent,
    OtherProductPlacementFormComponent,
    LoadListComponent,
    BoardLoadListComponent,
    IPBoardExtrasComponent,
    IPBoardSecondBoardComponent,
    IPBoardArrowsComponent,
    IpBoardHeightComponent,
    ClientProductWrapperComponent,
    ClientProductCreatorComponent,
    ClientIPBoardFormComponent,
    ClientSignSelectorComponent,
    ClientIPBoardPartFormComponent,
    ClientIpCustomBoardFormComponent,
    ClientWindowStickerFormComponent,
    ClientWindowStickerPartFormComponent,
    ClientWindowStickerStandardPartFormComponent,
    ClientWindowStickerCustomPartFormComponent,
    BoardFormComponent,
    BoardPartFormComponent,
    OtherProductFormComponent,
    StickerFacturationComponent,
    ImpersonateIconComponent,
    SignInfoComponent,
    SignInfoWrapperComponent,
    TourItemRegisteredComponent,
  ],
  declarations: [
    TabsComponent,
    TabContentComponent,
    TextareaInputComponent,
    ProjectTabsComponent,
    ProjectTabContentComponent,
    AsyncInsertionPointDirective,
    EmployeeWithBadgeComponent,
    AsyncEmployeeWithBadge,
    PersonNamePipe,
    AtelierNameDatePipe,
    InitialsPipe,
    PendingStatusTooltipPipe,
    StreetViewComponent,
    NoAccessComponent,
    CheckboxComponent,
    DualCheckboxComponent,
    SelectorComponent,
    YesNoComponent,
    YesNoUnknownComponent,
    SelectAutocompleteComponent,
    LabelWithTextAreaComponent,
    TimeBudgetPickerComponent,
    ProductTypeCriteriumSelectorComponent,
    FilePickerComponent,
    HeightAndWidthSelectorComponent,
    NumberInputComponent,
    TextFieldFilterComponent,
    ProductTypeCriteriumSelectorComponent,
    FilePickerComponent,
    InternalProjectFormComponent,
    CustomerProjectInfoAllComponent,
    CustomerProjectInfoOneComponent,
    TilingComponent,
    CompanyPickerComponent,
    ClientCompanyPickerComponent,
    LoggedActionDisplayComponent,
    FilterInputComponent,
    FilterDropdownComponent,
    FilterCheckboxComponent,
    FilterNotTrueBooleanComponent,
    NotificationModalComponent,
    ImmoStudioAssignModalComponent,
    PriceLinePickerComponent,
    PriceLineInputComponent,
    FloorPickerComponent,
    RegisteredActionDisplayComponent,
    ExecutionCollapseComponent,
    AppointmentCollapseComponent,
    DisplayNotExecutedHistoryItemComponent,
    DetailCardComponent,
    ConfigurationCardComponent,
    DesignCardComponent,
    PlacementCardComponent,
    PlacementCardAppointmentInfoComponent,
    PlacementCardIPBoardExtrasInfoComponent,
    ExecutionCardComponent,
    FacturationCardComponent,
    FacturationRowComponent,
    ClientDetailActionsComponent,
    ClientAdjustmentHeaderComponent,
    InternalInfoComponent,
    DivergentPriceCollapseComponent,
    IPBoardInvoicingComponent,
    IPBoardDelayComponent,
    IPBoardAppointmentComponent,
    IPBoardTourSelectorComponent,
    IPBoardCompanyInvoiceComponent,
    ClientBaseProjectPriceSummaryComponent,
    ClientIPBoardArrowsSummaryComponent,
    EmployeeCircleDisplayComponent,
    EmployeeRecoveryStatsComponent,
    DisplayDateTimePipe,
    IPBoardAdjustmentInvoicingComponent,
    IPBoardAdjustmentCompanyInvoiceComponent,
    ClientSubProjectOnHoldCollapseComponent,
    ClientSubProjectOnHoldContentComponent,
    ClientAdjustmentDesignCollapseComponent,
    ClientAdjustmentDesignContentComponent,
    ClientAdjustmentDesignDialogComponent,
    ClientAdjustmentPrintworkDialogComponent,
    OnlyNumbersDirective,
    FocusAndSelectDirective,
    NoScrollInputDirective,
    ClientAdjustmentSummaryComponent,
    ClientAdjustmentFormComponent,
    ClientAdjustmentFormSharedComponent,
    ClientAdjustmentActionsComponent,
    ClientAdjustmentPendingExecutedComponent,
    ClientAdjustmentExecutionInfoComponent,
    ClientAdjustmentInvoiceInfoComponent,
    ClientAdjustmentCompanyInvoiceInfoComponent,
    StickerSelectComponent,
    AdjustmentIPBoardAppointmentComponent,
    HrefExternalUrlDirective,
    IPBoardExecutedComponent,
    TestUnassignedExpiredSubProjectsModalComponent,
    MapComponent,
    CollectKeyFromSelectorComponent,
    PlacementStepComponent,
    DesignStepComponent,
    DesignPickerComponent,
    ProductDescriptionComponent,
    ProductPhoneNumberSelectorComponent,
    ClientProductPhoneNumberSelectorComponent,
    IPBoardPartPhoneNumberPickerComponent,
    IPBoardDesignPickerComponent,
    IPBoardDesignPreviewComponent,
    IPBoardExtraBoardInputComponent,
    IPBoardTitlePickerComponent,
    IPBoardPhoneNumberPickerComponent,
    IPBoardTextInputComponent,
    IPBoardStickerPickerComponent,
    IPBoardCustomBoardPhoneNumberPickerComponent,
    IPBoardCollaborativeTitlePickerComponent,
    IPBoardCollaborativeStickerInputComponent,
    PlacementPickerComponent,
    ProjectPlacementPickerComponent,
    ProductPlacementPickerComponent,
    WindowstickerPlacementFormComponent,
    BoardPlacementFormComponent,
    OtherProductPlacementFormComponent,
    LoadListComponent,
    BoardLoadListComponent,
    IPBoardExtrasComponent,
    IPBoardSecondBoardComponent,
    IPBoardArrowsComponent,
    IpBoardHeightComponent,
    ClientProductWrapperComponent,
    ClientProductCreatorComponent,
    ClientIPBoardFormComponent,
    ClientSignSelectorComponent,
    ClientIPBoardPartFormComponent,
    ClientIpCustomBoardFormComponent,
    ClientWindowStickerFormComponent,
    ClientWindowStickerPartFormComponent,
    ClientWindowStickerStandardPartFormComponent,
    ClientWindowStickerCustomPartFormComponent,
    BoardFormComponent,
    BoardPartFormComponent,
    OtherProductFormComponent,
    StickerFacturationComponent,
    ImpersonateIconComponent,
    SignInfoComponent,
    SignInfoWrapperComponent,
    TourItemRegisteredComponent,
  ],
})
export class SharedModule {}
